    const sha256Hex = async (str) => {
      const enc = new TextEncoder()
      const buf = await crypto.subtle.digest('SHA-256', enc.encode(str))
      return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('')
    }


  export default sha256Hex;